import axios from "axios";

const HIJRI_API_URL = "https://api.aladhan.com/v1/gToH?date=";

// Preferred transliterated Hijri month names with diacritics (uppercase)
const HIJRI_MONTHS_UPPER = [
  "MUHARRAM",
  "SAFAR",
  "RABĪʿ AL-AWWAL",
  "RABĪʿ AL-THĀNĪ",
  "JUMĀDĀ AL-ŪLĀ",
  "JUMĀDĀ AL-ĀKHIRAH",
  "RAJAB",
  "SHAʿBĀN",
  "RAMADĀN",
  "SHAWWĀL",
  "DHŪ AL-QIʿDAH",
  "DHŪ AL-ḤIJJAH"
];

// Returns: { formatted: string, day: number, month: { en: string, ar?: string }, year: number }
export async function getHijriDate(options = {}) {
  try {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();

    let url = `${HIJRI_API_URL}${day}-${month}-${year}`;
    const { lat, long } = options;
    if (typeof lat === "number" && typeof long === "number") {
      url += `&latitude=${lat}&longitude=${long}`;
    }

    const response = await axios.get(url);
    const hijri = response?.data?.data?.hijri;

    if (hijri && hijri.day && hijri.month && hijri.year) {
      const monthIndex = Number(hijri.month?.number) - 1;
      const monthName = HIJRI_MONTHS_UPPER[monthIndex] || String(hijri.month?.en || "").toUpperCase();
      // Required format: e.g., "15 RABĪʿ AL-THĀNĪ  1447" (double space before year, no AH)
      const formatted = `${Number(hijri.day)} ${monthName}  ${Number(hijri.year)}`;
      return {
        formatted,
        day: Number(hijri.day),
        month: { en: hijri.month.en, ar: hijri.month.ar, number: Number(hijri.month.number) },
        year: Number(hijri.year)
      };
    }

    throw new Error("Invalid Hijri data from API");
  } catch (error) {
    console.error("Hijri API error:", error.message);
    // Fallback: simple static label to avoid blank UI.
    return {
      formatted: "Hijri date unavailable",
    };
  }
}
